import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Button,
  Card,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginBottom: "10px",
    marginRight: "15px",
  },
  animatedButton: {
    background: "linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)",
    color: "#fff",
    padding: "10px 30px",
    fontSize: "16px",
    fontWeight: "bold",
    textTransform: "none",
    borderRadius: "5px",
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "scale(1.05)",
      background: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
    },
  },
});
const sourcingrows = [
  {
    id: 1,
    name: "Vendor 1",
    purchasecate: "Transactional SMS",
    communicationtype: "SMS",
    count: "70",
    validtype: "Limited",
    validfrom: "25/8/2025",
    validto: "25/8/2025",
    totalcost: "855",
    invoice: "856329",
  },
  {
    id: 2,
    name: "Vendor 1",
    purchasecate: "Transactional Whatsapp",
    communicationtype: "Whatsapp",
    count: "85",
    validtype: "Unlimited",
    validfrom: "25/8/2025",
    validto: "25/8/2025",
    totalcost: "521",
    invoice: "856325",
  },
];

const sourcingcolumns = [
  {
    field: "id",
    headerName: "S.No",
    width: 70,
    sortable: false,
  },
  { field: "name", headerName: "Vendor Name", width: 150 },
  { field: "purchasecate", headerName: "Purchase Category", width: 150 },
  { field: "communicationtype", headerName: "Communication Type", width: 200 },
  { field: "count", headerName: "Count", width: 120 },
  { field: "validtype", headerName: "Validity Type", width: 150 },
  { field: "validfrom", headerName: "Valid From", width: 150 },
  { field: "validto", headerName: "Valid To", width: 200 },
  { field: "totalcost", headerName: "Total Purchase Cost", width: 130 },
  { field: "invoice", headerName: "Invoice Number", width: 200 },
];

const tagitranferrow = [
  {
    id: 1,
    transdate: "5/5/2025",
    communicationtype: "SMS",
    count: "70",
    remarks: "Test",
  },
  {
    id: 2,
    transdate: "5/5/2025",
    communicationtype: "Whatsapp",
    count: "52",
    remarks: "Test",
  },
];

const tagitransfercolumns = [
  { field: "id", headerName: "S.No", width: 70, sortable: false },
  { field: "transdate", headerName: "Transfer Date", width: 150 },
  { field: "communicationtype", headerName: "Communication Type", width: 180 },
  { field: "count", headerName: "Transfer Count", width: 150 },
  { field: "remarks", headerName: "Remarks", width: 150 },
];
const tagireverrow = [
  {
    id: 1,
    transdate: "5/5/2025",
    communicationtype: "SMS",
    count: "70",
    remarks: "Test",
  },
  {
    id: 2,
    transdate: "5/5/2025",
    communicationtype: "Whatsapp",
    count: "52",
    remarks: "Test",
  },
];

const tagitrevcolumns = [
  { field: "id", headerName: "S.No", width: 70, sortable: false },
  { field: "transdate", headerName: "Reversed Date", width: 150 },
  { field: "communicationtype", headerName: "Communication Type", width: 180 },
  { field: "count", headerName: "Reversed Count", width: 150 },
  { field: "remarks", headerName: "Remarks", width: 150 },
];

const clientrows = [
  {
    id: 1,
    reversedate: "5/5/2025",
    communicationtype: "SMS",
    reversecount: "70",
    remarks: "Test",
    clientname: "sample",
  },
  {
    id: 2,
    reversedate: "5/5/2025",
    communicationtype: "Whatsapp",
    reversecount: "52",
    remarks: "Test",
    clientname: "sample",
  },
];

const clientcolumns = [
  { field: "id", headerName: "S.No", width: 70, sortable: false },
  { field: "reversedate", headerName: "Reverse Date", width: 150 },
  { field: "communicationtype", headerName: "Communication Type", width: 180 },
  { field: "reversecount", headerName: "Reverse Count", width: 150 },
  { field: "remarks", headerName: "Remarks", width: 150 },
  { field: "clientname", headerName: "Client Name (ID)", width: 150 },
];

const VendorList = () => {
  const [tagSubType, setTagSubType] = React.useState("");
  const [filterBy, setFilterBy] = React.useState("");
  const [type, setType] = React.useState("");
  const classes = useStyles();
  const getRowsAndColumns = () => {
    switch (type) {
      case "source":
        return { rows: sourcingrows, columns: sourcingcolumns };
      case "tag":
        if (tagSubType === "transfer") {
          return { rows: tagitranferrow, columns: tagitransfercolumns };
        } else if (tagSubType === "reverse") {
          return { rows: tagireverrow, columns: tagitrevcolumns };
        } else {
          return { rows: [], columns: [] };
        }
      case "client":
        return { rows: clientrows, columns: clientcolumns };
      default:
        return { rows: [], columns: [] };
    }
  };

  const { rows, columns } = getRowsAndColumns();

  return (
    <>
      <Card elevation={3} sx={{ marginBottom: "15px" }}>
        <Grid container spacing={2} sx={{ p: 2 }}>
          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel id="communication-type-label">
                Communication Type
              </InputLabel>
              <Select
                labelId="communication-type-label"
                id="communication-type-select"
                label="Communication Type"
              >
                <MenuItem value="sms">SMS</MenuItem>
                <MenuItem value="email">Email</MenuItem>
                <MenuItem value="whatsapp">Whatsapp</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel id="report-type-label">Report Type</InputLabel>
              <Select
                labelId="report-type-label"
                id="report-type-select"
                label="Report Type"
                onChange={(e) => setType(e.target.value)}
                value={type}
              >
                <MenuItem value="source">Sourcing Report</MenuItem>
                <MenuItem value="tag">TagitStore Report</MenuItem>
                <MenuItem value="client">Client Report</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {type === "source" && (
            <>
              <Grid item xs={12} md={3}>
                <TextField label="Name" name="name" fullWidth />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label="Mobile Number"
                  name="mobilenumber"
                  fullWidth
                  //   value={filters.mobilenumber}
                  //   onChange={(e) =>
                  //     setFilters({ ...filters, mobilenumber: e.target.value })
                  //   }
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label="Email"
                  name="mobilenumber"
                  fullWidth
                  //   value={filters.mobilenumber}
                  //   onChange={(e) =>
                  //     setFilters({ ...filters, mobilenumber: e.target.value })
                  //   }
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Sourced For
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    // value={age}
                    label="Sourced For"
                    // onChange={handleChange}
                  >
                    <MenuItem value="sms">SMS</MenuItem>
                    <MenuItem value="email">Email</MenuItem>
                    <MenuItem value="whatsapp">Whatsapp</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Inward type
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    // value={age}
                    label="Inward type"
                    // onChange={handleChange}
                  >
                    <MenuItem value="chennai">Purchased</MenuItem>
                    <MenuItem value="madurai">Expired Refersal</MenuItem>
                    <MenuItem value="salem">Adjustment Counts</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Validity Type
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    // value={age}
                    label="Validity Type"
                    // onChange={handleChange}
                  >
                    <MenuItem value="tamilnadu">Limited</MenuItem>
                    <MenuItem value="kerala">Unlimited</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </>
          )}

          {type === "tag" && (
            <>
              <Grid item xs={12} md={3}>
                <FormControl fullWidth>
                  <InputLabel id="type-select-label">Type</InputLabel>
                  <Select
                    labelId="type-select-label"
                    id="type-select"
                    label="Type"
                    value={tagSubType}
                    onChange={(e) => setTagSubType(e.target.value)}
                  >
                    <MenuItem value="transfer">Transfer</MenuItem>
                    <MenuItem value="reverse">Reversed</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={3}>
                <FormControl fullWidth>
                  <InputLabel id="filter-by-label">Filter By</InputLabel>
                  <Select
                    labelId="filter-by-label"
                    id="filter-by"
                    value={filterBy}
                    label="Filter By"
                    onChange={(e) => setFilterBy(e.target.value)}
                  >
                    <MenuItem value="trans">Transfer</MenuItem>
                    <MenuItem value="revers">Reversed</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {filterBy === "trans" && (
                <>
                  <Grid item xs={12} md={3}>
                    <TextField
                      label="Transfer Valid From"
                      type="date"
                      variant="outlined"
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      label="Transfer Valid To"
                      type="date"
                      variant="outlined"
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                </>
              )}

              {filterBy === "revers" && (
                <>
                  <Grid item xs={12} md={3}>
                    <TextField
                      label="Reversed Valid From"
                      type="date"
                      variant="outlined"
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      label="Reversed Valid To"
                      type="date"
                      variant="outlined"
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                </>
              )}
            </>
          )}

          {type === "client" && (
            <Grid item xs={12} md={3}>
              <TextField label="Client Name" name="clientname" fullWidth />
            </Grid>
          )}
        </Grid>

        <Box className={classes.buttonContainer}>
          <Button
            variant="outlined"
            onClick={() => {
              setType("");
              setTagSubType("");
            }}
          >
            Reset
          </Button>
          <Button className={classes.animatedButton} variant="contained">
            Search
          </Button>
        </Box>
      </Card>

      {((type === "tag" && tagSubType) || (type !== "tag" && type)) && (
        <Card elevation={3}>
          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={5}
            autoHeight
            disableSelectionOnClick
          />
        </Card>
      )}
    </>
  );
};

export default VendorList;
